import { Button } from '../../Utility/Button';
import AdminContainer from '../../Utility/AdminContainer';
import { PencilSimple, Trash } from '@phosphor-icons/react';
import useApiKeys from '../../../Hooks/useApiKeys';
import AdminBox from '../../Utility/AdminBox';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import AdminViewContent from '../../Utility/AdminViewContent';
import { ApiKey } from '../../../Types';
import { PaginationWrapper } from '../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../Types/PaginationParams';
import { apiKeyService } from '../../../Services/apiKeyService';
import SearchFilter from '../../Utility/SearchFilter';
import useSearchFilter from '../../../Hooks/useSearchFilter';

function ApiKeys() {
    const { ApiKeysActions, settings, i18n, getBreakpoint, windowWidth, apiKeys, handleNavigate } = useApiKeys();
    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });

    const GRID_COLS = 'grid-cols-[300px,1fr]';

    const handleEdit = (identifier: string) => {
        ApiKeysActions.handleEdit(identifier);
    };

    const handleOpenConfirmDialog = (apiKeyIdentifier: string) => {
        ApiKeysActions.handleOpenConfirmDialog(apiKeyIdentifier);
    };

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <SearchFilter
                        value={localQuery}
                        onChange={searchActions.setLocalQuery}
                        onApply={searchActions.applyQuery}
                        onClear={searchActions.clearQuery}
                        className="mb-6"
                    />
                    <div className="hidden md:block">
                        <AdminViewHeader
                            gridCols={GRID_COLS}
                            cols={{
                                cols: [
                                    {
                                        text: i18n.translate({ id: 'adminHeader.mainCol', sourceName: 'Main' }),
                                    },
                                ],
                                button: {
                                    text: i18n.translate({ id: 'newApiKey.button', sourceName: 'ApiKeys' }),
                                    function: () => handleNavigate('new'),
                                    renderCondition: settings.apiKeyLicences > apiKeys.length,
                                },
                            }}
                        />
                        <hr className="border-layout-borderColor mt-5" />
                    </div>

                    <div className="mb-4 block md:hidden">
                        {settings.apiKeyLicences > apiKeys.length && (
                            <Button
                                className="!m-0 !mb-3 flex justify-center items-center w-full"
                                onClick={() => handleNavigate('new')}
                            >
                                {i18n.translate({ id: 'newApiKey.button', sourceName: 'ApiKeys' })}
                            </Button>
                        )}
                    </div>

                    <PaginationWrapper
                        listType={PaginationListType.ApiKeys}
                        itemsFunction={apiKeyService.getApiKeys}
                        itemsPerPage={15}
                        query={query || null}
                        renderItem={(apiKey: ApiKey, index: number) => (
                            <AdminViewContent
                                key={apiKey.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={apiKey.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: apiKey.name,
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleEdit(apiKey.identifier),
                                                icon: <PencilSimple />,
                                            },
                                            {
                                                variant: 'secondaryRound',
                                                onClick: () => handleOpenConfirmDialog(apiKey.identifier),
                                                tooltipText: i18n.translate({
                                                    id: 'tooltip.deleteAssistant',
                                                    sourceName: 'Prompts',
                                                }),
                                                icon: <Trash />,
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    />
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default ApiKeys;
